import { render, staticRenderFns } from "./PTitle.vue?vue&type=template&id=cb27949e&scoped=true&"
import script from "./PTitle.vue?vue&type=script&lang=ts&"
export * from "./PTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PTitle.vue?vue&type=style&index=0&id=cb27949e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb27949e",
  null
  
)

export default component.exports